import React from 'react';
import { graphql } from 'gatsby';
import * as Styles from './rich-text-kahoot.module.scss';

function RichTextKahoot({ kahootId }) {
  return (
    <div className={Styles.root}>
      <iframe
        src={`https://kahoot.it/challenge/?quiz-id=${kahootId}&single-player=true&embed=true`}
        name="kahoot-embed"
        title={kahootId}
        scrolling="no"
        frameBorder="0"
        width="100%"
        height="520px"
        allow="fullscreen"
      />
    </div>
  );
}

export const query = graphql`
  fragment RichTextKahootFields on ContentfulKahoot {
    contentful_id
    title
    kahootId
    internal {
      type
    }
  }
`;

export default RichTextKahoot;
